import FindingTemplate from '../../common/template/FindingTemplate';

const ConfirmingJob = () => {
    return <FindingTemplate title={'Confirming your job'} subTitle={"instafix is confirming your booking..."}/>;
};

export default ConfirmingJob;